export default function AboutHero() {
  return (
    <section className="relative overflow-hidden bg-background-100 border-b border-background-200">
      <div className="absolute -top-20 right-0 w-72 h-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-content mx-auto py-14 md:py-20">
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-foreground-500">
            <a href="/" className="hover:text-primary-600 cursor-pointer">
              Home
            </a>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-700">About the Clinic</span>
          </nav>

          <span className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
            <span className="w-6 h-px bg-primary-400" />
            About the Clinic
          </span>
          <h1 className="mt-4 font-heading text-3xl md:text-5xl font-extrabold leading-[1.1] text-foreground-950 max-w-3xl">
            A Private Medical Practice Serving Miami
          </h1>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-600 max-w-2xl">
            Florida Family Clinic offers orthopedic care, pain-related services, diagnostic testing,
            and medically supervised wellness support in a convenient outpatient setting.
          </p>
        </div>
      </div>
    </section>
  );
}